var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailabilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.925 9C0.925 13.4524 4.54755 17.075 9 17.075C13.4524 17.075 17.075 13.4524 17.075 9C17.075 4.54755 13.4524 0.925 9 0.925C4.54755 0.925 0.925 4.54755 0.925 9ZM1.73795 9C1.73795 4.99562 4.99562 1.73795 9 1.73795C13.0044 1.73795 16.262 4.99562 16.262 9C16.262 13.0044 13.0044 16.262 9 16.262C4.99562 16.262 1.73795 13.0044 1.73795 9Z",
    fill: "#948B9E",
    stroke: "#948B9E",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.59352 2.53684C8.59352 2.76148 8.77536 2.94331 8.99999 2.94331C9.22463 2.94331 9.40647 2.76148 9.40647 2.53684V1.33148C9.40647 1.10684 9.22463 0.925 8.99999 0.925C8.77536 0.925 8.59352 1.10684 8.59352 1.33148V2.53684Z",
    fill: "#948B9E",
    stroke: "#948B9E",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.59352 16.6686C8.59352 16.8932 8.77536 17.075 8.99999 17.075C9.22463 17.075 9.40647 16.8932 9.40647 16.6686V15.4632C9.40647 15.2386 9.22463 15.0567 8.99999 15.0567C8.77536 15.0567 8.59352 15.2386 8.59352 15.4632V16.6686Z",
    fill: "#948B9E",
    stroke: "#948B9E",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.33148 9.40641H2.53684C2.76148 9.40641 2.94331 9.22457 2.94331 8.99993C2.94331 8.7753 2.76148 8.59346 2.53684 8.59346H1.33148C1.10684 8.59346 0.925 8.7753 0.925 8.99993C0.925 9.22457 1.10684 9.40641 1.33148 9.40641Z",
    fill: "#948B9E",
    stroke: "#948B9E",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.4632 9.40641H16.6686C16.8932 9.40641 17.075 9.22457 17.075 8.99993C17.075 8.7753 16.8932 8.59346 16.6686 8.59346H15.4632C15.2386 8.59346 15.0567 8.7753 15.0567 8.99993C15.0567 9.22457 15.2386 9.40641 15.4632 9.40641Z",
    fill: "#948B9E",
    stroke: "#948B9E",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.71482 9.8925L8.71468 9.89236L6.99886 8.19944C6.83931 8.04211 6.83692 7.78429 6.99509 7.6245C7.15263 7.46412 7.4105 7.46275 7.57009 7.62078L7.57006 7.62075L7.51739 7.67414L7.57018 7.62086L8.71482 9.8925ZM8.71482 9.8925C8.77458 9.95114 8.848 9.98786 8.92499 10.0023M8.71482 9.8925L8.92499 10.0023M8.92499 10.0023V10.0104H8.99999C9.10495 10.0104 9.2099 9.9697 9.28952 9.88935L9.28963 9.88924L12.6748 6.45828C12.6748 6.45824 12.6749 6.45821 12.6749 6.45817C12.8331 6.29838 12.8307 6.04054 12.6712 5.8832C12.5111 5.72533 12.2538 5.7265 12.0962 5.88696M8.92499 10.0023L12.0962 5.88696M12.0962 5.88696L12.0962 5.88695L12.1496 5.93962L12.0961 5.88708C12.0961 5.88704 12.0962 5.887 12.0962 5.88696ZM8.99686 9.02837L8.94419 9.08176L8.99758 9.13444L9.05025 9.08105L8.99686 9.02837Z",
    fill: "#948B9E",
    stroke: "#948B9E",
    strokeWidth: 0.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailabilityIcon);
export default __webpack_public_path__ + "static/media/availability-icon.3a941b653c2b870c2236226f52da3ade.svg";
export { ForwardRef as ReactComponent };